import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { BlockingModalType, type BlockingModalOptions, type BlockingModalState } from "./types";

const initialState: BlockingModalState = {
  visible: false,
  type: BlockingModalType.loading,
  options: {
    title: "",
    content: null,
  },
};

export const blockingModalSlice = createSlice({
  name: "blockingModal",
  initialState,
  reducers: {
    setBlockingModalOptions: (state, action: PayloadAction<BlockingModalOptions>) => {
      state.options = action.payload;
    },
    setLoadingIsVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
      state.type = BlockingModalType.loading;
    },
    setConfirmIsVisible: (
      state,
      action: PayloadAction<{ open: boolean; handleCancel?: () => void }>,
    ) => {
      state.visible = action.payload.open;
      state.type = BlockingModalType.confirm;
      state.handleCancel = action.payload.handleCancel;
    },
  },
  selectors: {
    selectIsVisible: (state: BlockingModalState) => state.visible,
    selectOptions: (state: BlockingModalState) => state.options,
    selectHandleCancel: (state: BlockingModalState) => state.handleCancel,
    selectType: (state: BlockingModalState) => state.type,
  },
});

export const { actions: blockingModalActions, selectors: blockingModalSelectors } =
  blockingModalSlice;
